module.exports = __webpack_public_path__ + "img/p2-bg.0894762e.jpg";